const SCOPE_HEADER_KEYS = ['org-id', 'tenant-id'] as const

const SENTINEL_SCOPE_VALUES = new Set(['', 'undefined', 'null'])

/**
 * A scope header value is a "sentinel" when it carries no real id: it is
 * absent, empty, whitespace, or one of the literal client serialization
 * artifacts ('undefined' / 'null'). The API treats an omitted scope header as
 * a deliberate all-orgs read, so sentinels must be stripped rather than sent.
 */
export function isSentinelScopeValue (value: unknown): boolean {
  if (value === null || value === undefined) {
    return true
  }

  return SENTINEL_SCOPE_VALUES.has(String(value).trim().toLowerCase())
}

/**
 * Return a copy of `headers` with the `org-id` / `tenant-id` headers removed
 * when their value is a sentinel, so the API never receives a literal
 * "undefined"/"null" scope header that would silently widen the query.
 */
export function cleanScopeHeaders<T extends Record<string, unknown>> (headers: T): T {
  const cleaned: Record<string, unknown> = { ...headers }

  for (const key of SCOPE_HEADER_KEYS) {
    if (isSentinelScopeValue(cleaned[key])) {
      delete cleaned[key]
    }
  }

  return cleaned as T
}
